import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import BlogDescription from "../components/description/BlogDescription";
import RelatedBlogs from "../components/RelatedBlogs";
import { fetchBlog } from "../features/blog/BlogSlice";

export default function BlogDetail() {
	const { blog, isLoading, isError, errorMessage } = useSelector(state => state.blog);

	const dispatch = useDispatch();
	const { blogId } = useParams();

	useEffect(() => {
		dispatch(fetchBlog(blogId));
	}, [dispatch, blogId]);

	const { id, tags } = blog || {};

	let content = null;
	if (isLoading) {
        content = <div>Blogs loading...</div>;
    }
    else if (!isLoading && isError) {
        content = <div>{errorMessage}</div>;
    }
    else if (!isLoading && !isError && !!blog) {
        content =  (
			<section className="post-page-container">
				<BlogDescription blog={blog} />
				<RelatedBlogs currentBlogId={id} tags={tags} />
			</section>
		);
    }
    else {
        content = <div>No blogs found!!</div>;
    }

	return (
		<>
			<div className="container mt-8">
				<Link
					to="/"
					className="inline-block text-gray-600 home-btn"
					id="lws-goHome"
				>
					<i className="mr-2 fa-solid fa-house"></i>Go Home
				</Link>
			</div>
			{content}
		</>
	);
}
